import React from 'react';

import { cn } from '~/lib/utils';

interface GameLevelsProps {
  levels: string[];
  currentLevelIdx: number;
}

function formatLevelName(level: string) {
  return level.replace(/-/g, ' ');
}

export function GameLevels({ levels, currentLevelIdx }: GameLevelsProps) {
  return (
    <div className='mt-8 self-stretch pb-11' style={{ '--levels': levels.length } as React.CSSProperties}>
      <dl className='grid-cols-(--levels) ring-asphalt-25 grid h-4 grid-rows-[20px_24px] gap-x-1 rounded-full ring-1 ring-offset-4'>
        {levels.map((level, levelIdx) => (
          <React.Fragment key={level}>
            <dt
              className={cn(
                'row-start-1 h-4 first-of-type:rounded-l-full last-of-type:rounded-r-full',
                levelIdx <= currentLevelIdx && 'bg-teal',
                levelIdx > currentLevelIdx && 'bg-muted',
              )}
            >
              <span className='sr-only'>
                Level {levelIdx + 1}
                {levelIdx <= currentLevelIdx ? ', completed' : ', not completed'}
              </span>
            </dt>
            <dd className='row-start-2 mt-4 text-center'>
              <svg
                aria-label={formatLevelName(level)}
                className='inline-block h-6 w-6'
                fill='none'
                focusable='false'
                role='img'
                xmlns='http://www.w3.org/2000/svg'
              >
                <use xlinkHref={`#${level}`} />
              </svg>
            </dd>
          </React.Fragment>
        ))}
      </dl>
    </div>
  );
}
